import React from 'react';

export default function LoadingSpinner() {
  return (
    <div role="status" className="flex items-center justify-center h-full">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-400"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
}